import { useEffect, useRef } from 'react';

export default function KakaoMap() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    function initMap() {
      if (!window.daum?.roughmap?.Lander) {
        setTimeout(initMap, 100);
        return;
      }

      new window.daum.roughmap.Lander({
        timestamp: '1779757975082',
        key: 'of76cumw4ny',
        mapWidth: '100%',
        mapHeight: window.innerWidth <= 768 ? '300' : '540',
      }).render();
    }

    initMap();
  }, []);

  return (
    <div
      id="daumRoughmapContainer1779757975082"
      className="root_daum_roughmap root_daum_roughmap_landing"
      style={{ width: '100%' }}
    />
  );
}